import * as yup from 'yup';

export const schemaChardeBalance = yup.object().shape({
  amount: yup.number().positive().required('Campo requerido'),
});
